export function reloadCaptcha($captcha) {
	const captchaId = Math.random().toString(36).substr(2, 10);
	const captchaUrl = `/captcha/${captchaId}.jpg`;

	// $captcha.data('captchaId', captchaId);
	$captcha.find('.js-captcha__id').val(captchaId);
	$captcha.find('.js-captcha__image').attr('src', captchaUrl);
}

export function setValidState($captcha, state) {
	$captcha.find('.js-captcha__text').attr('data-parsley-captcha', String(state));
}

$('.js-captcha__text').click(function () {
	$(this).select();
});

$('.js-captcha__reload').on('click', function () {
	const $captcha = $(this).parents('.captcha');
	reloadCaptcha($captcha);
});

$('.captcha').each(function () {
	reloadCaptcha($(this));
});

global.blurOnLeave($('.js-captcha__reload'));



// WEBPACK FOOTER //
// ./temp/components/captcha/index.js